document.addEventListener("turbo:load", function () {
  const mailchimpForm = document.getElementById("mc_embed_signup");

  if (mailchimpForm) {
    function getParameterByName(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name) || "";
    }

    function addFormElem(paramName, fieldName) {
      const paramValue = getParameterByName(paramName);
      if (paramValue !== "") {
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = fieldName;
        hiddenInput.value = paramValue;

        // Select all forms and append the hidden field to each
        document.querySelectorAll("form").forEach(form => {
          form.prepend(hiddenInput.cloneNode(true));
        });
      }
    }

    const utmParams = {
      utm_source: "USOURCE",
      utm_medium: "UMEDIUM",
      utm_campaign: "UCAMPAIGN",
      utm_content: "UCONTENT",
      utm_term: "UTERM",
    };

    Object.keys(utmParams).forEach(param => {
      addFormElem(param, utmParams[param]);
    });
  }
});